const BASE_URL = process.env.REACT_APP_API_URL || 'https://enessafoods.com';

export const getHomepageData = async () => {
  const url = `${BASE_URL}/api/homepage/data/`;
  console.log('Fetching homepage data from:', url);
  return fetch(url).then(res => {
    console.log('Homepage API response status:', res.status);
    return res.json();
  });
};

export const getServices = async () => {
  const url = `${BASE_URL}/api/services/`;
  console.log('Fetching services from:', url);
  return fetch(url).then(res => res.json());
};

export const getProducts = async () => {
  const url = `${BASE_URL}/api/products/`;
  console.log('Fetching products from:', url);
  return fetch(url).then(res => res.json());
};

export const getBlogs = async () => {
  const url = `${BASE_URL}/api/blogs/`;
  console.log('Fetching blogs from:', url);
  return fetch(url).then(res => res.json());
};